// extracted by mini-css-extract-plugin
export default {"tabContain":"style_tabContain__fUxiF","tabs":"style_tabs__CSeAg","active":"style_active__wz76d","formContent":"style_formContent__luBHY"};